import { render, staticRenderFns } from "./MarkSheetCocurricular.vue?vue&type=template&id=63f61a0a"
import script from "./MarkSheetCocurricular.vue?vue&type=script&lang=js"
export * from "./MarkSheetCocurricular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports